import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { ButtonTriggerEvent } from '../../../../common/components';
import { TravelBuddyConversationsModalData } from './travel.buddy.conversations.modal.provider';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';

@Component({
  templateUrl: './travel.buddy.conversations.modal.component.html',
  styleUrls: ['./travel.buddy.conversations.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TravelBuddyConversationsModalComponent extends BaseComponent {
  public loadingAccounts = false;
  public loadingUsers = false;
  public accountNames: string[] = [];
  public users: string[] = [];
  public accountName = '';
  public userName = '';
  public conversations = [];

  public account: TravelBuddyConversationsModalData;
  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private apiService: SchedulerApiService,
    private alertify: AlertifyService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private dialogRef: MatDialogRef<TravelBuddyConversationsModalComponent>,
    data: TravelBuddyConversationsModalData
  ) {
    super();
    this.account = Object.assign({}, data);
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      assistantId: [null, null],
    });

    this.loadingAccounts = true;

    this.apiService
      .getTravelBuddyConversationClientAggregation()
      .finally(() => (this.loadingAccounts = false))
      .subscribe((data) => {
        this.accountNames = data.map((x) => x._id);
        console.log(this.accountNames);
      });
  }

  setAccount(account: string) {
    this.accountName = account;
    this.conversations = [];
    this.users = [];
    this.userName = '';

    this.apiService.getTravelBuddyConversationUserAggregation(this.accountName).subscribe((data) => {
      this.users = data.map((x) => x._id); // hatfield.randy@gmail.com|google
    });
  }

  setUser(userId: string) {
    this.userName = this.processUser(userId);
    this.conversations = [];
    this.apiService.getTravelBuddyConversationByUser(this.accountName, userId).subscribe((data) => {
      console.log(data);
      this.conversations = data.filter((x) => !!x.conversation); // filter out those client not allowed to track conversation
    });
  }

  processUser(userId: string) {
    return userId.split('|')[0];
  }

  getConversationTitle(conversation) {
    return `${new Date(conversation.createdAt).toLocaleString()} (${conversation.timeConsumed.toFixed(1)}s)`;
  }

  close() {
    this.dialogRef.close();
  }

  confirm(event: ButtonTriggerEvent) {}
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component.ts